import { useMutation, useQueryClient } from '@tanstack/react-query';
import { HyperlinkRequest } from 'src/api/FiretrolApiClient';
import { hyperlinkApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useSaveHyperlink() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ jobId, body }: { jobId: number; body: HyperlinkRequest }) =>
      hyperlinkApiClient.createOrUpdateHyperlink(jobId, body),
    meta: { successMessage: 'Hyperlink saved!' },
    onSettled: (_data, _err, { jobId }) =>
      invalidateFor('hyperlink.save', qc, { jobId }),
  });
}

export function useRemoveHyperlink() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      jobId,
      hyperlinkId,
    }: {
      jobId: number;
      hyperlinkId: string;
    }) => hyperlinkApiClient.removeHyperlink(jobId, hyperlinkId),
    meta: { successMessage: 'Hyperlink removed!' },
    onSettled: (_data, _err, { jobId }) =>
      invalidateFor('hyperlink.save', qc, { jobId }),
  });
}
